/**
 * @generated SignedSource<<5647eb93aa035c28164ee011d8849738>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PortfolioStakingOverviewQuery$variables = Record<PropertyKey, never>;
export type PortfolioStakingOverviewQuery$data = {
  readonly overview: {
    readonly totalRewardsFiat: PrecisionFloat | null | undefined;
    readonly totalStakedFiat: PrecisionFloat | null | undefined;
  } | null | undefined;
};
export type PortfolioStakingOverviewQuery = {
  response: PortfolioStakingOverviewQuery$data;
  variables: PortfolioStakingOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "overview",
    "args": null,
    "concreteType": "StakingOverview",
    "kind": "LinkedField",
    "name": "stakingOverview",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalRewardsFiat",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalStakedFiat",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PortfolioStakingOverviewQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PortfolioStakingOverviewQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "d74f404419cbaaf1f2f39ee30d2f2b09",
    "id": null,
    "metadata": {},
    "name": "PortfolioStakingOverviewQuery",
    "operationKind": "query",
    "text": "query PortfolioStakingOverviewQuery {\n  overview: stakingOverview {\n    totalRewardsFiat\n    totalStakedFiat\n  }\n}\n"
  }
};
})();

(node as any).hash = "a0ee5b1aff981d0d82005d972a7f0043";

export default node;
